export default __webpack_public_path__ + "static/media/E_Contract.fdcc7eb4.jpg";